import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.white')};
  padding: 60px 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    justify-content: space-between;
    padding: 60px;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 820px;

  h2,
  h3 {
    margin-bottom: 10px;
  }
`;

export const Contact = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 50px;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 0;
    margin-left: 50px;
  }
`;
